import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Accueil',
      component: () => import('./views/home.vue')
    },
    {
      path: '/entrainement',
      name: "S'entrainer",
      component: () => import('./views/test.vue')
    },

    {
      path: '/contact',
      name: "Contact",
      component: () => import('./views/contact.vue')
    },
    {
      path: '/bug',
      name: "Bug",
      component: () => import('./views/bug.vue')
    },
    {
      path: '/app',
      name: "Application",
      component: () => import('./views/app.vue')
    },

    {
      path: '/cgu',
      name: "Mentions légales",
      component: () => import('./views/cgu.vue')
    },
    {
      path: '/privacy',
      name: "Politique de confidentialité",
      component: () => import('./views/privacy.vue')
    },
    {
      path: '/info',
      name: "Info",
      component: () => import('./views/info.vue')
    },



    {
      path: '/:name',
      name: "UE",
      component: () => import('./views/ue.vue')
    },
    {
      path: '/:name/test',
      name: "Test UE",
      component: () => import('./views/quiz.vue')
    },
    {
      path: '/:ue_name/quiz/:quiz_id',
      name: "Quiz",
      component: () => import('./views/quiz.vue')
    },
  ]
})
